export default __webpack_public_path__ + "static/media/sms.2c7461f0.svg";